"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuebec = exports.getRegionOptions = exports.getRegionDisplayName = void 0;
const country_1 = require("../enums/country");
const registry_1 = require("./registry");
const DISPLAY_NAME_LOOKUP = new Map();
for (const [countryCode, entries] of registry_1.REGION_REGISTRY) {
    const map = new Map();
    for (const entry of entries) {
        map.set(entry.code, entry.displayName);
    }
    DISPLAY_NAME_LOOKUP.set(countryCode, map);
}
const getRegionDisplayName = (country, code) => {
    if (!code) {
        return "";
    }
    const countryCode = (0, registry_1.toCountryCode)(country);
    if (!countryCode) {
        return code;
    }
    return DISPLAY_NAME_LOOKUP.get(countryCode)?.get(code) ?? code;
};
exports.getRegionDisplayName = getRegionDisplayName;
const getRegionOptions = (country) => {
    const countryCode = (0, registry_1.toCountryCode)(country);
    if (!countryCode) {
        return [];
    }
    return (registry_1.REGION_REGISTRY.get(countryCode) ?? []).map((entry) => ({ code: entry.code, label: entry.displayName }));
};
exports.getRegionOptions = getRegionOptions;
const isQuebec = (country, code) => (0, registry_1.toCountryCode)(country) === country_1.CountryCode.CA && code === "QC";
exports.isQuebec = isQuebec;
